import { style } from '@vanilla-extract/css';

export const agencyLink = style({
  textDecoration: 'none',
  selectors: {
    '&:hover': { textDecoration: 'underline' },
  },
});
